// Copyright (c) 2016 Deere & Company

import MassChannelPdiContainer from '../../claim/marketing/mass-channel-pdi/state-connector';

export default {
    component: MassChannelPdiContainer,
    name: 'MARKETING_MASS_CHANNEL_PDI',
    path: 'mass-channel-pdi/new'
};



// WEBPACK FOOTER //
// ./src/routes/claims/mass-channel-pdi-route.js